import $ from 'jquery';
import {formatPrice} from '@utils/commonUtils.js';
import priceCalculationService from '../services/priceCalculationService';

/**
 * @typedef {'flight'|'hotel'|'ticket'} PackageType
 */

const isTicketCategoryAllowedForTicketOnly = ($category) => {
        const allowTicketOnly = $category.data('allow-ticket-only-booking');

        return allowTicketOnly === true || allowTicketOnly === 'true';
    },

    showAllTicketCategories = () => {
        $('.ticket-category').removeClass('d-none');
    },

    showOnlyAllowedCategories = () => {
        $('.ticket-category').each(function() {
            const $category = $(this),
            isAllowed = isTicketCategoryAllowedForTicketOnly($category);
            
            $category.toggleClass('d-none', !isAllowed);
        });
    },

    getFirstVisibleTicketButton = () => $('.ticket-category')
            .not('.d-none')
            .first()
            .find('.package-bookBtn'),

    selectFirstVisibleTicketCategory = () => {
        const $firstVisibleButton = getFirstVisibleTicketButton();
        
        if ($firstVisibleButton.length) {
            $firstVisibleButton.trigger('click');
        }
    },

    handleHiddenSelectedCategory = () => {
        const $selectedButton = $('.package-bookBtn.active');
        
        if (!$selectedButton.length) {
            return;
        }
        
        const $selectedCategory = $selectedButton.closest('.ticket-category'),
        isSelectedCategoryHidden = $selectedCategory.hasClass('d-none');
        
        if (isSelectedCategoryHidden) {
            selectFirstVisibleTicketCategory();
        }
    },

    /**
     * @param {PackageType} packageType
     */
    filterTicketCategories = (packageType) => {
        const isTicketOnlyMode = packageType === 'ticket';
        
        if (!isTicketOnlyMode) {
            showAllTicketCategories();

            return;
        }
        
        showOnlyAllowedCategories();
        handleHiddenSelectedCategory();
    },

    /**
     * @param {PackageType} packageType
     */
    updateTicketCategoryPrices = (packageType) => {
        $('.package-price-flight, .package-price-hotel, .package-price-ticket').addClass('d-none');
        $(`.package-price-${packageType}`).removeClass('d-none');
        
        filterTicketCategories(packageType);
    },

    /**
     * @param {Object} arrangement
     */
    updatePackageTypeSelectorPrices = (arrangement) => {
        const calculatedPrices = priceCalculationService.calculatePackagePrices(arrangement),
        $flightPrice = $('.package-type-row[data-package-type="flight"] .price-value'),
        $hotelPrice = $('.package-type-row[data-package-type="hotel"] .price-value'),
        $ticketPrice = $('.package-type-row[data-package-type="ticket"] .price-value');
        
        if ($flightPrice.length) {
            $flightPrice.text(formatPrice(calculatedPrices.flight));
        }

        if ($hotelPrice.length) {
            $hotelPrice.text(formatPrice(calculatedPrices.hotel));
        }

        if ($ticketPrice.length) {
            $ticketPrice.text(formatPrice(calculatedPrices.ticket));
        }
    },

    /**
     * @param {PackageType} packageType
     */
    syncPackageTypeSelector = (packageType) => {
        $('.package-type-row').removeClass('active');
        $(`.package-type-radio-input[value="${packageType}"]`).prop('checked', true);
        
        updateTicketCategoryPrices(packageType);
    };

export {
    updateTicketCategoryPrices,
    updatePackageTypeSelectorPrices,
    syncPackageTypeSelector
};